export default "__VITE_ASSET__BdXikUxs__"